const CERTS = [
  { icon: 'ri-government-line', title: 'PAGCOR Licensed', desc: 'Bybid9 is officially licensed by the Philippine Amusement and Gaming Corporation, ensuring strict regulatory compliance and operational transparency.' },
  { icon: 'ri-test-tube-line', title: 'BMM Testlabs Certified', desc: "All games at Bybid9 undergo rigorous testing by BMM Testlabs, the world's oldest and most experienced gaming test laboratory." },
  { icon: 'ri-fingerprint-line', title: 'ThreatMetrix Protection', desc: 'Real-time fraud detection and identity verification powered by ThreatMetrix, protecting every transaction and account at Bybid9.' },
  { icon: 'ri-lock-password-line', title: '256 bit SSL encryption', desc: 'Bank-grade encryption protects all data transmission between your device and our servers. Your information never leaves our secure environment.' },
  { icon: 'ri-award-line', title: 'eCOGRA Certified', desc: 'Certified by eCOGRA for fair gaming, responsible operator conduct, and player protection standards at Bybid9.' },
  { icon: 'ri-shield-star-line', title: 'TST Verified', desc: 'Technical Systems Testing (TST) verifies the integrity and randomness of our RNG systems for complete game fairness at Bybid9.' },
];

export default function TrustSection() {
  return (
    <div className="relative" style={{ background: 'linear-gradient(180deg, #0d1117 0%, #091520 50%, #0d1117 100%)' }}>
      <div className="section-divider absolute top-0 left-0 w-full"></div>

      {/* Certs */}
      <div className="py-14 sm:py-16 md:py-20 px-4 sm:px-5 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <div className="badge-blue mb-5">
              <i className="ri-shield-check-line"></i> Trust &amp; Security
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-3 px-1">Licensed, Certified, and Secure</h2>
            <p className="text-[#56626B] text-base max-w-xl mx-auto">Bybid9 does not just claim to be safe. We prove it with multiple independent certifications and regulatory oversight.</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {CERTS.map((c) => (
              <div key={c.title} className="glass-card rounded-2xl p-6 flex flex-col gap-3 card-hover-glow">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl" style={{ background: 'rgba(71,202,241,0.1)', border: '1px solid rgba(71,202,241,0.2)' }}>
                  <i className={`${c.icon} text-[#47CAF1] text-lg`}></i>
                </div>
                <h4 className="text-white font-bold text-sm">{c.title}</h4>
                <p className="text-[#56626B] text-xs leading-relaxed">{c.desc}</p>
              </div>
            ))}
          </div>

          {/* Responsible Gambling */}
          <div className="mt-8 sm:mt-10 glass-card rounded-2xl sm:rounded-3xl p-5 sm:p-8 md:p-12" style={{ border: '1px solid rgba(71,202,241,0.15)' }}>
            <div className="flex flex-col md:flex-row items-start gap-6">
              <div className="w-16 h-16 flex items-center justify-center rounded-2xl flex-shrink-0" style={{ background: 'rgba(71,202,241,0.1)', border: '1px solid rgba(71,202,241,0.25)' }}>
                <i className="ri-heart-pulse-line text-[#47CAF1] text-3xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-xl sm:text-2xl font-black text-white mb-3">Responsible Gambling Commitment</h3>
                <p className="text-[#56626B] text-sm leading-relaxed mb-4">
                  At Bybid9, we believe gambling should always be fun, never harmful. We are committed to promoting responsible gaming through a comprehensive suite of player protection tools and resources.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
                  {['Self-exclusion options', 'Deposit limits', 'Session time reminders', 'Reality checks', 'Account cooling-off periods', 'Access to gambling support services'].map((item) => (
                    <div key={item} className="flex items-center gap-2 text-[#56626B] text-xs">
                      <i className="ri-check-double-line text-[#47CAF1] text-sm flex-shrink-0"></i>
                      {item}
                    </div>
                  ))}
                </div>
                <div className="rounded-xl p-4" style={{ background: 'rgba(71,202,241,0.05)', border: '1px solid rgba(71,202,241,0.15)' }}>
                  <p className="text-[#56626B] text-xs leading-relaxed">
                    <strong className="text-white">Need help?</strong> If gambling is affecting your life, please contact{' '}
                    <a href="https://www.gamblinghelponline.org.au/" target="_blank" rel="noreferrer" className="text-[#47CAF1] underline font-semibold">Gambling Help Online</a>{' '}
                    or call the National Gambling Helpline on <strong className="text-white">1800 858 858</strong>. Bybid9 is strictly 18+. Gamble responsibly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section-divider mx-4 md:mx-8"></div>

    </div>
  );
}
